(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('monitor', {
            parent: 'entity',
            url: '/monitor?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.monitor.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/monitor/monitors.html',
                    controller: 'MonitorController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('monitor');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('monitor-detail', {
            parent: 'monitor',
            url: '/monitor/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.monitor.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/monitor/monitor-detail.html',
                    controller: 'MonitorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('monitor');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Monitor', function($stateParams, Monitor) {
                    return Monitor.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'monitor',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('monitor-detail.edit', {
            parent: 'monitor-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/monitor/monitor-dialog.html',
                    controller: 'MonitorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Monitor', function(Monitor) {
                            return Monitor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('monitor.new', {
            parent: 'monitor',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/monitor/monitor-dialog.html',
                    controller: 'MonitorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fecha: null,
                                nroterminal: null,
                                versiondesoft: null,
                                cpuserial: null,
                                cputemp: null,
                                cpureboot: null,
                                tottxbytes: null,
                                toterrconex: null,
                                serialok: null,
                                serialreopen: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('monitor', null, { reload: 'monitor' });
                }, function() {
                    $state.go('monitor');
                });
            }]
        })
        .state('monitor.edit', {
            parent: 'monitor',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/monitor/monitor-dialog.html',
                    controller: 'MonitorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Monitor', function(Monitor) {
                            return Monitor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('monitor', null, { reload: 'monitor' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('monitor.delete', {
            parent: 'monitor',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/monitor/monitor-delete-dialog.html',
                    controller: 'MonitorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Monitor', function(Monitor) {
                            return Monitor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('monitor', null, { reload: 'monitor' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
